var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.line)?_c('div',{staticClass:"p-mb-2",class:{ 'p-invalid': _vm.line.error },attrs:{"id":"activityOutlookSync"}},[_c('i',{staticClass:"pi pi-calendar p-mr-1"}),_vm._v(" "+_vm._s(_vm.line.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }